import type React from 'react';
import { DEFAULT_DATE_FORMAT } from '@/lib/constants/common';
import translate from '@/lib/intl/translate';
import { formatDate } from '@/utils/dates';
import type DynamicKey from '../types/DynamicKey';

export function generateKey<DataType extends object>(
  key: DynamicKey<DataType> | string,
  row: DataType,
) {
  if (typeof key === 'string') {
    return key in row ? row[key as keyof DataType] : key;
  }

  return key(row);
}

export function generateRowColumnKey<DataType extends object>(
  row: DataType,
  rowKey: DynamicKey<DataType> | string,
  columnKey: DynamicKey<DataType> | string,
) {
  return `${generateKey(rowKey, row)}-${columnKey}`;
}

export function formatDateWithDefaultFormat({ date }: { date: string }) {
  return formatDate(date, DEFAULT_DATE_FORMAT);
}

export function renderHeaderName(headerName?: string | React.ReactNode) {
  if (!headerName) return null;

  return typeof headerName === 'string' ? translate(headerName) : headerName;
}

export default {
  formatDateWithDefaultFormat,
  generateRowColumnKey,
  generateKey,
  renderHeaderName,
};
